import { render, staticRenderFns } from "./WebshopProductTable.vue?vue&type=template&id=530d9144&"
import script from "./WebshopProductTable.vue?vue&type=script&lang=js&"
export * from "./WebshopProductTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports